/**
 * Meta Pixel (Facebook) utility module.
 * All fbq calls are guarded — if fbq is unavailable (blocked, missing ID),
 * every function is a silent no-op.
 */

function isFbqAvailable() {
  return typeof window.fbq === 'function';
}

export function trackMetaViewContent() {
  if (!isFbqAvailable()) return;
  window.fbq('track', 'ViewContent');
}

export function trackMetaInitiateCheckout() {
  if (!isFbqAvailable()) return;
  window.fbq('track', 'InitiateCheckout');
}

export function trackMetaStartTrial(predictedLtv) {
  if (!isFbqAvailable()) return;
  window.fbq('track', 'StartTrial', {
    value: '0.00',
    currency: 'USD',
    predicted_ltv: String(predictedLtv || '0.00'),
  });
}
